module.exports = __webpack_public_path__ + "img/crc-03.d93d9d5d.jpg";